import { useT } from "@/i18n/LanguageContext";

/**
 * Visually hidden skip link — becomes visible on focus (Tab key).
 * Helps keyboard / screen reader users bypass navigation to reach main content.
 */
export default function SkipLink() {
  const { t } = useT();
  return (
    <a
      href="#main"
      data-testid="skip-to-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[10000] focus:bg-ink focus:text-bone focus:px-4 focus:py-3 focus:font-mono focus:text-[11px] focus:tracking-[0.3em] focus:uppercase"
    >
      {t("nav.skip_to_content")}
    </a>
  );
}
